// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  ControlVariant,
  unionToControlVariant,
  unionListToControlVariant,
} from "./control-variant";
import { NormalControl, NormalControlT, verifyNormalControl } from "./normal-control";
import { ValuedControl, ValuedControlT, verifyValuedControl } from "./valued-control";

export class ElevatorControlMessage implements flatbuffers.IUnpackableObject<ElevatorControlMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElevatorControlMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElevatorControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorControlMessage,
  ): ElevatorControlMessage {
    return (obj || new ElevatorControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsElevatorControlMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorControlMessage,
  ): ElevatorControlMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElevatorControlMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  controlType(): ControlVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ControlVariant.NONE;
  }

  control<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  static startElevatorControlMessage(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addControlType(builder: flatbuffers.Builder, controlType: ControlVariant) {
    builder.addFieldInt8(0, controlType, ControlVariant.NONE);
  }

  static addControl(builder: flatbuffers.Builder, controlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, controlOffset, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(2, position, 0);
  }

  static endElevatorControlMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // control
    return offset;
  }

  static createElevatorControlMessage(
    builder: flatbuffers.Builder,
    controlType: ControlVariant,
    controlOffset: flatbuffers.Offset,
    position: number,
  ): flatbuffers.Offset {
    ElevatorControlMessage.startElevatorControlMessage(builder);
    ElevatorControlMessage.addControlType(builder, controlType);
    ElevatorControlMessage.addControl(builder, controlOffset);
    ElevatorControlMessage.addPosition(builder, position);
    return ElevatorControlMessage.endElevatorControlMessage(builder);
  }

  unpack(): ElevatorControlMessageT {
    return new ElevatorControlMessageT(
      this.controlType(),
      (() => {
        const temp = unionToControlVariant(this.controlType(), this.control.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.position(),
    );
  }

  unpackTo(_o: ElevatorControlMessageT): void {
    _o.controlType = this.controlType();
    _o.control = (() => {
      const temp = unionToControlVariant(this.controlType(), this.control.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.position = this.position();
  }

  unpackFields(...fields: string[]): ElevatorControlMessageT {
    const t = new ElevatorControlMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("control_type")) {
      t.controlType = this.controlType();
    }
    if (fieldSet.has("control")) {
      t.control = (() => {
        const temp = unionToControlVariant(this.controlType(), this.control.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    return t;
  }
}

export class ElevatorControlMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public controlType: ControlVariant = ControlVariant.NONE,
    public control: NormalControlT | ValuedControlT | null = null,
    public position: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.control === null || this.control === undefined) {
      throw new Error('Required field "control" is not set');
    }
    const control = builder.createObjectOffset(this.control);

    return ElevatorControlMessage.createElevatorControlMessage(
      builder,
      this.controlType,
      control,
      this.position,
    );
  }

  clone(): ElevatorControlMessageT {
    const obj = new ElevatorControlMessageT();
    obj.controlType = this.controlType;
    obj.control =
      this.control !== null && typeof (this.control as any).clone === "function"
        ? (this.control as any).clone()
        : this.control;
    obj.position = this.position;
    return obj;
  }

  equals(other: ElevatorControlMessageT): boolean {
    if (this.controlType !== other.controlType) return false;
    if (this.control !== null && other.control !== null) {
      if (typeof (this.control as any).equals === "function") {
        if (!(this.control as any).equals(other.control)) return false;
      } else if (this.control !== other.control) return false;
    } else if (this.control !== other.control) return false;
    if (this.position !== other.position) return false;
    return true;
  }
}

export function verifyElevatorControlMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "control");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalControl
            {
              const o = verifier.readInt32(pos);
              verifyNormalControl(verifier, pos + o);
            }
            break;
          case 2: // ValuedControl
            {
              const o = verifier.readInt32(pos);
              verifyValuedControl(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "control");
    verifier.checkScalarField(tablePos, 8, 2);
  } finally {
    verifier.popDepth();
  }
}
